import React from 'react';
import { Box, useTheme } from '@mui/material';

const ICON_DARK = '/static/assets/anamnesis/AnamnesisDarkTheme.svg';
const ICON_LIGHT = '/static/assets/anamnesis/AnamnesisLightTheme.svg';

/** Theme-aware Anamnesis brand mark for the sidebar accordion header. */
export const AnamnesisSidebarIcon: React.FC = () => {
  const theme = useTheme();
  const src = theme.palette.mode === 'dark' ? ICON_DARK : ICON_LIGHT;

  return (
    <Box
      component="img"
      src={src}
      alt=""
      aria-hidden
      sx={{
        width: 24,
        height: 24,
        display: 'block',
        objectFit: 'contain',
        flexShrink: 0,
      }}
    />
  );
};

export default AnamnesisSidebarIcon;
